import script from "./WithdrawSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawSummary.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawSummary.vue?vue&type=style&index=0&id=c5b2d470&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5b2d470"]])

export default __exports__